import React from "react";
import sra from "../../assets/images/review/sra.png";
import adb from "../../assets/images/review/adb.png";
import may from "../../assets/images/review/mayl.png";
import IntegrationBanner from "../../assets/images/integration/integrationBanner.png";

const features = [
  {
    title: "Simple Integration with Popular Travel Platforms",
    desc: "Easily connect to major platforms like Airbnb, Vrbo, and Booking.com. Our seamless integration keeps your listings up-to-date with zero hassle.",
    img: IntegrationBanner,
  },
  {
    title: "Sync Rates and Availability in Real-Time",
    desc: "Ensure consistency with real-time syncing of rates and availability across all your channels. Any change you make is instantly reflected, preventing errors and maximizing bookings.",
    img: sra,
  },
  {
    title: "Avoid Double Bookings with Smart Calendar Management",
    desc: "Our smart calendar management updates availability automatically, helping you avoid double bookings and ensuring peace of mind.",
    img: adb,
  },
  {
    title: "Manage All Your Listings from One Dashboard",
    desc: "Control everything from a single, easy-to-use dashboard. Update rates, availability, and content in one place—saving you time and effort.",
    img: may,
  },
];

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-20">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Distribute with Confidence
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Broaden Your Distribution and <br />
            Reach More <span className="tw-text-[#5D44FF]">Potential Customers</span>
          </h2>
        </div>

        {/* Alternating Layout Blocks */}
        <div className="tw-space-y-12">
          {features.map((item, idx) => {
            const isEven = idx % 2 === 0;
            return (
              <div
                key={idx}
                className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-[32px] tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-300"
              >
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 tw-items-center">
                  
                  {/* Text Container */}
                  <div className={`md:tw-col-span-7 tw-text-left ${isEven ? "md:tw-order-1" : "md:tw-order-2"}`}>
                    <h3 className="tw-text-lg sm:tw-text-xl tw-font-extrabold tw-text-slate-800 tw-mb-4">
                      {item.title}
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                      {item.desc}
                    </p>
                  </div>

                  {/* Image Container */}
                  <div className={`md:tw-col-span-5 tw-flex tw-justify-center ${isEven ? "md:tw-order-2" : "md:tw-order-1"}`}>
                    <div className="tw-overflow-hidden tw-rounded-2xl hover:tw-scale-[1.03] tw-transition-transform tw-duration-300">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="tw-max-w-full tw-h-auto tw-object-contain"
                        loading="lazy"
                      />
                    </div>
                  </div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
